import { NextRequest } from 'next/server';

export const getLocaleFromHost = (req: NextRequest): 'ru' | 'az' => {
  const forwardedHost =
    req.headers.get('x-forwarded-host') || req.headers.get('host') || '';
  return forwardedHost.startsWith('ru.') ? 'ru' : 'az';
};

export const cleanHtmlExtension = (pathname: string): string =>
  pathname.endsWith('.html') ? pathname.replace(/\.html$/, '') : pathname;
